import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { Logo } from "@/components/Logo";

// Placeholder links — point at real pages as they're built.
const COLUMNS = [
  {
    heading: "Product",
    links: [
      { label: "AI Visualization", to: "/products", route: true },
      { label: "Product Catalog", to: "/products", route: true },
      { label: "Analytics", to: "/products", route: true },
      { label: "Integrations", to: "/products", route: true },
      { label: "API", to: "/products", route: true },
    ],
  },
  {
    heading: "Solutions",
    links: [
      { label: "Furniture", to: "/solutions#industries", route: true },
      { label: "Paint", to: "/solutions#industries", route: true },
      { label: "Flooring", to: "/solutions#industries", route: true },
      { label: "Interior Design", to: "/solutions#industries", route: true },
      { label: "Real Estate", to: "/solutions#industries", route: true },
      { label: "Enterprise", to: "/solutions", route: true },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Blog", to: "/resources", route: true },
      { label: "Guides", to: "/resources", route: true },
      { label: "Case Studies", to: "/resources", route: true },
      { label: "Webinars", to: "/resources", route: true },
      { label: "Documentation", to: "/resources", route: true },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", to: "/about", route: true },
      { label: "Careers", to: "#" },
      { label: "Contact Us", to: "/contact", route: true },
      { label: "Partners", to: "#" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Privacy Policy", to: "#" },
      { label: "Terms of Service", to: "#" },
      { label: "Cookie Policy", to: "/cookie-policy", route: true },
    ],
  },
];

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Linkedin, label: "LinkedIn", href: "#" },
  { icon: Twitter, label: "Twitter", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
];

export default function Footer() {
  return (
    <footer className="border-t border-neutral-200 bg-neutral-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-3 lg:grid-cols-7">
          <div className="col-span-2 lg:col-span-2">
            <Logo />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-neutral-500">
              Experience every product before you buy. AI-powered visualization
              for retailers, manufacturers, and interior designers.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-neutral-200 text-neutral-500 transition-colors hover:border-primary hover:text-primary"
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.heading}>
              <h4 className="text-sm font-bold uppercase tracking-wider text-neutral-900">
                {col.heading}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.route ? (
                      <Link to={link.to} className="text-sm text-neutral-500 transition-colors hover:text-primary">
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.to} className="text-sm text-neutral-500 transition-colors hover:text-primary">
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-neutral-200 pt-8 sm:flex-row">
          <p className="text-sm text-neutral-400">
            © {new Date().getFullYear()} NEIV. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-neutral-400 transition-colors hover:text-primary">Privacy</a>
            <a href="#" className="text-sm text-neutral-400 transition-colors hover:text-primary">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
